var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('aside',{attrs:{"id":"card-container"}},_vm._l((_vm.structuresList),function(structure){return _c(_setup.StructureCard,{key:structure.id,attrs:{"is-selected":_setup.isSelected(structure),"structure":structure},on:{"select-structure":_setup.handleSelectStructure}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }